import { decorateWithTimestampsForFirestore, removeUndefineds, removeNulls } from './FirestoreUtils'

function parseUser (doc) {
  let user = doc.data()
  user.email = doc.id
  return user
}

export default class UserService {
  constructor (db) {
    this.db = db
    this.users = db.collection('users')
  }

  ref (email) {
    return this.users.doc(email)
  }

  async getUsers () {
    let users = []
    let snapshot = await this.users.get()
    if (snapshot.size > 0) {
      snapshot.docs.forEach(doc => { users.push(parseUser(doc)) })
    }
    return users
  }

  async getUser (email) {
    let doc = await this.users.doc(email).get()
    if (doc.exists) {
      return parseUser(doc)
    }
    return null
  }

  prepUserToSave (user) {
    let userToSave = {
      uid: user.uid,
      photoURL: user.photoURL,
      displayName: user.displayName,
      phoneNumber: user.phoneNumber,
      providerId: user.providerId
    }
    if (user.organization) {
      userToSave.organization = user.organization
    }
    if (user.orgSetup) {
      userToSave.orgSetup = user.orgSetup
      removeNulls(userToSave.orgSetup)
      removeUndefineds(userToSave.orgSetup)
    }
    decorateWithTimestampsForFirestore(userToSave)
    removeUndefineds(userToSave)
    removeNulls(userToSave)
    return userToSave
  }

  addUser (user) {
    let userToSave = this.prepUserToSave(user)
    return this.users.doc(user.email).set(userToSave, { merge: true })
  }

  async addSousChefOperator (user) {
    await this.addUser(user)
    return this.db.collection('ops').doc(user.email).set({}, { merge: true })
  }

  async deleteSousChefOperator (user) {
    await this.db.collection('users').doc(user.email).delete()
    return this.db.collection('ops').doc(user.email).delete()
  }

  async getSousChefOps () {
    let ops = []
    let snapshot = await this.db.collection('ops').get()
    for (let i = 0; i < snapshot.size; i++) {
      ops.push(await this.getUser(snapshot.docs[i].id))
    }
    return ops
  }

  async isSousChefAdmin (user) {
    try {
      let doc = await this.db.collection('admins').doc(user.uid).get()
      return doc.exists
    } catch (e) {
      return false
    }
  }
}
